/** The bank block as a workbook sheet, and the per-row account mark. */

import type { Cell, WriteSheet } from '../../lib/roster/xlsxWrite'
import type { PayRow } from '../../lib/payroll'

/** The bank block as one workbook sheet, in the payroll export. */
export function bankSheet(tsv: string, name: string): WriteSheet {
  return { name, rows: bankSheetRows(tsv), cols: [24, 28, 12, 40, 10, 16] }
}

/** Workbook rows; the account stays text so a numeric-looking account keeps its leading zeros. */
export function bankSheetRows(tsv: string): Cell[][] {
  const lines = tsv.split('\n').filter((line) => line !== '')
  return lines.map((line, index) => {
    const cells = line.split('\t')
    if (index === 0) return cells
    return cells.map((value, col): Cell => {
      if (col === 0) return { v: value, t: 'text' }
      if (col === cells.length - 1) {
        const amount = Number(value.replace(/,/g, ''))
        return Number.isFinite(amount) ? amount : value
      }
      return value
    })
  })
}
/** Only a KNOWN gap is marked: an absent status says nothing rather than "missing". */
export function rowAccountMark(status: PayRow['bank_account_status']): 'none' | 'noPrimary' | null {
  if (status === 'none') return 'none'
  if (status === 'no_primary') return 'noPrimary'
  return null
}
